import { forwardRef, useCallback, useImperativeHandle, useState } from 'react';
import './ConnectionsPage.scss';
import { FoldingCube } from 'better-react-spinkit';
import { useTheme } from '@emotion/react';
import { ItemConnection, ItemConnectionModel } from './items/ItemConnection';

import { ModalSelectConnectionAssetAccount } from './modals/ModalSelectConnectionAssetAccount';
import Pagination from 'components/pagination/Pagination';

interface ConnectionData {
    loading: boolean;
    error?: Error;
    data?: {
        id: number | string | null; // Relax from just 'number' to support what useTable returns
        details: {
            pageNumber: number;
            pageSize: number;
            resultsCount: number;
            listData: Array<{
                senderId: number;
                receiverId: number;
                customerId: number;
                connectionID: number;
                networkConnectionStatus: string;
                senderName: string;
                receiverName: string;
            }>;
            sortBy: Record<string, unknown>;
            filters: any[]; // Improve later if needed
            lastPage: number;
            firstOnPage: number;
            lastOnPage: number;
            hasNextPage: boolean;
            hasPrevPage: boolean;
            summaryRows?: any[];
        };
        status: string;
        errors: any[];
        actions: {
            goToNextPage(): void;
            goToPrevPage(): void;
            changePageSize(size: number): void;
            goToPage(page: number): void;
        };
    };
    reload: () => void;
}

interface AllConnectionsListProps {
    transactionsTable: ConnectionData;
    activeTabParent?:string
}

export const AllConnectionsList = forwardRef(
    ({ transactionsTable, activeTabParent }: AllConnectionsListProps, ref) => {
        const [makePaymentConnection, setMakePaymentConnection] = useState<
            ItemConnectionModel | undefined
        >();
        const { data, loading, reload } = transactionsTable;
        const { colors } = useTheme();
        const handleMakePayment = useCallback((connection: ItemConnectionModel) => {
            setMakePaymentConnection(connection);
        }, []);

        useImperativeHandle(ref, () => ({
            refreshData: reload,
        }));

        return (
            <>
                <div className="list-container-networks">
                    {loading && (
                        <div className="PageLoader">
                            <FoldingCube color={colors.first} size={80} />
                        </div>
                    )}

                    {!loading &&
                        data &&
                        data?.details?.listData?.length > 0 &&
                        data?.details?.listData.map((item: ItemConnectionModel, index: number) => (
                            <ItemConnection
                                key={item.receiverId + '_' + index}
                                networkUser={item}
                                makePayment={handleMakePayment}
                                refreshList={transactionsTable?.reload}
                            />
                        ))}
                    {!loading && data && data?.details?.listData?.length === 0 && (
                        <div className="no-results-message">No results found</div>
                    )}
                    {!loading && data && data?.details?.listData?.length > 0 && (
                        <Pagination table={transactionsTable} />
                    )}
                </div>
                {makePaymentConnection && (
                    <ModalSelectConnectionAssetAccount
                        closeModal={() => setMakePaymentConnection(undefined)}
                        selectedConnection={makePaymentConnection}
                        activeTabParent={activeTabParent}
                    />
                )}
            </>
        );
    }
);
